import React, { ReactElement, useEffect } from 'react';
import { To, useLocation, useOutletContext } from 'react-router-dom';
import CTALink from '../../components/buttons/CTALink';
import { formatTitle } from '../../components/document-title/DocumentTitle';
import { analytics, RESOURCE_NOT_FOUND } from '../../helpers/analytics';
import PageNotFoundIcon from '../../icons/2-chain.svg';
import { ResultPageLayout } from '../../layouts/ResultPageLayout';
import { RestaurantGuardOutletContext } from '../../routes/RestaurantGuard';
import { useTranslation } from 'react-i18next';

export interface NotFoundErrorPageProps {
	to?: To;
}

export function NotFoundErrorPage({ to }: NotFoundErrorPageProps) {
	const location = useLocation();
	const { t } = useTranslation();
	// we can't deconstruct here ({ restaurant }) because the restaurant itself my be not found
	// which would make the context undefined
	const context = useOutletContext<RestaurantGuardOutletContext>();

	let button: ReactElement | null = null;

	if (to) {
		button = <CTALink text={t('actions.go_back')} to={to} />;
	}
	else if (context?.restaurant) {
		button = <CTALink text={t('actions.go_to_homepage')} to={`/${context?.restaurant.slug}`} />;
	}

	useEffect(() => {
		analytics.track(RESOURCE_NOT_FOUND, {
			...location
		});
	}, []);

	useEffect(() => {
		document.title = formatTitle(t('titles.document_title_page_not_found'));
	}, [t]);

	return (
		<ResultPageLayout headerIcon={PageNotFoundIcon} iconAltText='Broken Link Icon'>
			<ResultPageLayout.Title>{t('titles.oops')}</ResultPageLayout.Title>

			<ResultPageLayout.Body>
				<p>{t('error_pages.not_found_body')}</p>
			</ResultPageLayout.Body>

			<ResultPageLayout.Footer>{button}</ResultPageLayout.Footer>
		</ResultPageLayout>
	);
}
